import axios from "axios";
import { axiosPrivate } from "src/common/axiosProtected.jsx";
import { axiosPublic } from "src/common/axiosPublic.jsx";

// const BASE_URL = process.env.SERVER_API_BASEURL;

export const Login = async (values, fcmToken = null) => {
  try {
    const payload = fcmToken ? { ...values, fcmToken } : values;
    const response = await axios.post(`/api/v1/auth/logIn`, payload);
    if (response.status !== 200) {
      throw new Error(response.data ?? "Request Failed.");
    }
    return response;
  } catch (error) {
    throw new Error(error.response?.data?.message ?? "Request Failed.");
  }
};

export const updateCustomerAccounting = async (accountingUuid, payload) => {
  if (!accountingUuid) {
    throw new Error(
      "accountingUuid is required to update accounting settings.",
    );
  }

  try {
    const response = await axiosPrivate.put(
      `/api/v1/customer-accounting/update/${accountingUuid}`,
      payload,
    );

    if (response.status !== 200) {
      throw new Error(response.data?.message ?? "Request Failed.");
    }

    return response.data;
  } catch (error) {
    console.error("Request Error:", error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? "Request Failed.");
  }
};

export const sendManifestToDriver = async (manifestUuid, driverUuid) => {
  try {
    const payload = {
      manifestUuid,
      driverUuid,
    };
    const response = await axiosPrivate.post(
      `/api/v1/manifests/send-to-driver`,
      payload,
    );
    if (response.status !== 200) {
      throw new Error(response.data?.message ?? "Request Failed.");
    }
    return response.data.data;
  } catch (error) {
    console.error("Request Error:", error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? "Request Failed.");
  }
};

export const sendManifestToDispatchers = async (
  manifestUuid,
  dispatcherUuids,
) => {
  try {
    const response = await axiosPrivate.post(
      `/api/v1/manifests/${manifestUuid}/send-to-dispatchers`,
      { dispatcherUuids },
    );
    if (response.status !== 200) {
      throw new Error(response.data?.message ?? "Request Failed.");
    }
    return response.data;
  } catch (error) {
    console.error("Request Error:", error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? "Request Failed.");
  }
};

export const getCustomerAccounting = async (customerUuid) => {
  if (!customerUuid) {
    throw new Error("customerUuid is required to fetch accounting settings.");
  }

  try {
    const response = await axiosPrivate.get(
      `/api/v1/customer-accounting/by-customer/${customerUuid}`,
    );

    if (response.status !== 200) {
      throw new Error(response.data?.message ?? "Request Failed.");
    }

    return response.data?.data ?? response.data;
  } catch (error) {
    console.error("Request Error:", error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? "Request Failed.");
  }
};

export const createCustomerAccounting = async (payload) => {
  try {
    const response = await axiosPrivate.post(
      `/api/v1/customer-accounting/create`,
      payload,
    );

    if (response.status !== 200 && response.status !== 201) {
      throw new Error(response.data?.message ?? "Request Failed.");
    }

    return response.data;
  } catch (error) {
    console.error("Request Error:", error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? "Request Failed.");
  }
};

export const importCsv = async (values) => {
  try {
    const response = await axiosPrivate.post(`/api/v1/uploads/csv`, values);

    if (response.status !== 200) {
      throw new Error(response.data.message ?? "Request Failed.");
    }

    return response;
  } catch (error) {
    console.error("Request Error:", error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? "Request Failed.");
  }
};
export const getAllRoles = async () => {
  try {
    const response = await axiosPrivate.get(`/api/v1/roles/all`);

    if (response.status !== 200) {
      throw new Error(response.data.message ?? "Request Failed.");
    }

    return response;
  } catch (error) {
    console.error("Request Error:", error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? "Request Failed.");
  }
};

export const getAllOrders = async (params = {}, isOSND = false) => {
  const query = params?.params ? `${params.params}` : "";
  try {
    let response;
    if (isOSND) {
      response = await axiosPrivate.get(`/api/v1/osnd/all${query}`);
    } else {
      response = await axiosPrivate.get(`/api/v1/orders/all${query}`);
    }

    if (response.status !== 200) {
      throw new Error(response.data.message ?? "Request Failed.");
    }

    // Transform OS&D data structure to match regular orders format
    if (isOSND && response.data?.data) {
      const transformedData = {
        ...response.data,
        data: response.data.data.map((osndRecord) => ({
          ...osndRecord.order,
          osndInfo: {
            uuid: osndRecord.uuid,
            type: osndRecord.type,
            description: osndRecord.description,
            orderId: osndRecord.orderId,
            createdAt: osndRecord.createdAt,
            updatedAt: osndRecord.updatedAt,
          },
        })),
      };
      return transformedData;
    }

    return response.data;
  } catch (error) {
    console.error("Request Error:", error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? "Request Failed.");
  }
};
export const getAllCustomers = async () => {
  try {
    const response = await axiosPrivate.get(
      `/api/v1/customers/all?page=1&limit=500`,
    );

    if (response.status !== 200) {
      throw new Error(response.data.message ?? "Request Failed.");
    }

    return response;
  } catch (error) {
    console.error("Request Error:", error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? "Request Failed.");
  }
};
export const getCustomerTerms = async (id) => {
  try {
    const response = await axiosPrivate.get(
      `/api/v1/customers-terms-and-conditions/by-customer/${id}`,
    );

    if (response.status !== 200) {
      throw new Error(response.data.message ?? "Request Failed.");
    }

    return response;
  } catch (error) {
    console.error("Request Error:", error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? "Request Failed.");
  }
};
export const getCustomerTariffs = async (id, page) => {
  try {
    const response = await axiosPrivate.get(
      `/api/v1/tariffs/${
        page === "customer" ? "customer" : "carrier"
      }/${id}/tariffs`,
    );

    if (response.status !== 200) {
      throw new Error(response.data.message ?? "Request Failed.");
    }

    return response;
  } catch (error) {
    console.error("Request Error:", error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? "Request Failed.");
  }
};

export const updateCustomerTerm = async (values) => {
  try {
    const response = await axiosPrivate.put(
      `/api/v1/customers-terms-and-conditions/update/${values.uuid}`,
      values,
    );

    if (response.status !== 200) {
      throw new Error(response.data.message ?? "Request Failed.");
    }

    return response;
  } catch (error) {
    console.error("Request Error:", error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? "Request Failed.");
  }
};
export const createCustomerTerm = async (values) => {
  try {
    const response = await axiosPrivate.post(
      `/api/v1/customers-terms-and-conditions/create`,
      values,
    );
    if (response.status !== 201) {
      throw new Error(response.data.message ?? "Request Failed.");
    }

    return response;
  } catch (error) {
    console.error("Request Error:", error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? "Request Failed.");
  }
};

export const deleteCustomerTerms = async (uuids) => {
  const response = await axiosPrivate.delete(
    `/api/v1/customers-terms-and-conditions/delete`,
    { data: { uuids } },
  );
  if (response.status !== 200) {
    throw new Error(response.data ?? "Request Failed.");
  }
  return response;
};

export const changeOrderType = async (values) => {
  const response = await axiosPrivate.put(
    `/api/v1/orders/update-order-type/${values.orderId}`,
    { orderType: values.orderType },
  );
  if (response.status !== 200) {
    throw new Error(response.data ?? "Request Failed.");
  }
  return response;
};
export const deleteOrderStop = async (values) => {
  const response = await axiosPrivate.delete(`/api/v1/orders/delete-stops`, {
    data: values,
  });
  if (response.status !== 200) {
    throw new Error(response.data ?? "Request Failed.");
  }
  return response;
};

export const getCarriers = async () => {
  try {
    const response = await axiosPrivate.get(
      `/api/v1/carriers/all?page=1&limit=500`,
    );

    if (response.status !== 200) {
      throw new Error(response.data.message ?? "Request Failed.");
    }

    return response;
  } catch (error) {
    console.error("Request Error:", error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? "Request Failed.");
  }
};
export const getAllCarriersForOrder = async (uuid) => {
  try {
    const response = await axiosPrivate.get(`api/v1/quotes/carriers/${uuid}`);

    if (response.status !== 200) {
      throw new Error(response.data.message ?? "Request Failed.");
    }

    return response;
  } catch (error) {
    console.error("Request Error:", error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? "Request Failed.");
  }
};
export const quickQuoteData = async (values) => {
  try {
    const response = await axiosPrivate.post(`api/v1/quotes/quick-quote`, {
      ...values,
    });

    if (response.status !== 200) {
      throw new Error(response.data.message ?? "Request Failed.");
    }

    return response;
  } catch (error) {
    console.error("Request Error:", error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? "Request Failed.");
  }
};
export const getEquipments = async () => {
  try {
    const response = await axiosPrivate.get(
      `/api/v1/equipments/all?page=1&limit=500`,
    );

    if (response.status !== 200) {
      throw new Error(response.data.message ?? "Request Failed.");
    }

    return response;
  } catch (error) {
    console.error("Request Error:", error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? "Request Failed.");
  }
};
export const Drivers = async () => {
  try {
    const response = await axiosPrivate.get(
      `/api/v1/users/all/drivers?page=1&limit=500`,
    );

    if (response.status !== 200) {
      throw new Error(response.data.message ?? "Request Failed.");
    }

    return response;
  } catch (error) {
    console.error("Request Error:", error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? "Request Failed.");
  }
};
export const Tags = async () => {
  try {
    const response = await axiosPrivate.get(
      `/api/v1/tags/all?page=1&limit=500`,
    );

    if (response.status !== 200) {
      throw new Error(response.data.message ?? "Request Failed.");
    }

    return response;
  } catch (error) {
    console.error("Request Error:", error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? "Request Failed.");
  }
};

export const getAllCommodityTypes = async () => {
  try {
    const response = await axiosPrivate.get(`/api/v1/commodity-types/all`);

    if (response.status !== 200) {
      throw new Error(response.data.message ?? "Request Failed.");
    }

    return response;
  } catch (error) {
    console.error("Request Error:", error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? "Request Failed.");
  }
};
export const createCommodity = async (values) => {
  try {
    const response = await axiosPrivate.post(
      `/api/v1/commodities/create`,
      values,
    );

    if (response.status !== 200) {
      throw new Error(response.data.message ?? "Request Failed.");
    }

    return response;
  } catch (error) {
    console.error("Request Error:", error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? "Request Failed.");
  }
};
export const updateCommodity = async (values) => {
  try {
    const response = await axiosPrivate.put(
      `/api/v1/commodities/update/${values.uuid}`,
      values,
    );

    if (response.status !== 200) {
      throw new Error(response.data.message ?? "Request Failed.");
    }

    return response;
  } catch (error) {
    console.error("Request Error:", error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? "Request Failed.");
  }
};
export const createOrder = async (values) => {
  try {
    const response = await axiosPrivate.post(`/api/v1/orders/create`, values);

    if (response.status !== 200) {
      throw new Error(response.data.message ?? "Request Failed.");
    }

    return response;
  } catch (error) {
    console.error("Request Error:", error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? "Request Failed.");
  }
};

export const updateOrder = async (uuid, values) => {
  try {
    const response = await axiosPrivate.put(
      `/api/v1/orders/update/${uuid}`,
      values,
    );

    if (response.status !== 200) {
      throw new Error(response.data.message ?? "Request Failed.");
    }

    return response;
  } catch (error) {
    console.error("Request Error:", error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? "Request Failed.");
  }
};

export const updateBillingParty = async (orderUuid, billingPartyUuid) => {
  try {
    const response = await axiosPrivate.put(
      `/api/v1/orders/update-billing-party/${orderUuid}`,
      { billingPartyUuid },
    );

    if (response.status !== 200) {
      throw new Error(response.data.message ?? "Request Failed.");
    }

    return response;
  } catch (error) {
    console.error("Request Error:", error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? "Request Failed.");
  }
};

export const createAccessorial = async (values) => {
  const response = await axiosPrivate.post(
    `/api/v1/accessorials/create`,
    values,
  );

  return response;
};
export const updateAccessorial = async (values) => {
  const response = await axiosPrivate.put(
    `/api/v1/accessorials/update/${values.uuid}`,
    values,
  );

  return response;
};
export const deleteAccessorials = async (values) => {
  const response = await axiosPrivate.delete(`/api/v1/accessorials/delete`, {
    data: values,
  });

  return response;
};

export const getAllZones = async (params = {}) => {
  const query = new URLSearchParams(params).toString();

  const response = await axiosPrivate.get(`/api/v1/zones/all?${query}`);

  return response;
};
export const createZone = async (values) => {
  const response = await axiosPrivate.post(`/api/v1/zones/create`, values);

  return response;
};
export const updateZone = async (values) => {
  const response = await axiosPrivate.put(
    `/api/v1/zones/update/${values.uuid}`,
    values,
  );

  return response;
};
export const deleteZone = async (values) => {
  const response = await axiosPrivate.delete(`/api/v1/zones/delete`, {
    data: values,
  });

  return response;
};
export const getAllAccessorials = async (params = {}) => {
  const query = new URLSearchParams(params).toString();
  const response = await axiosPrivate.get(`/api/v1/accessorials/all?${query}`);

  return response;
};

export const addAccessorialsToOrderStop = async (
  orderStopUuid,
  accessorials,
) => {
  try {
    const payload = {
      accessorialUuids: accessorials.map((a) => a.uuid),
    };
    const response = await axiosPrivate.put(
      `/api/v1/orders/order-stops/${orderStopUuid}/accessorials`,
      payload,
    );

    return response;
  } catch (error) {
    console.error("Error adding accessorials:", error);
    throw new Error(
      error.response?.data?.message ?? "Failed to add accessorials",
    );
  }
};

export const removeAccessorialsFromOrderStop = async (
  orderStopUuid,
  accessorials,
) => {
  try {
    const response = await axiosPrivate.delete(
      `/api/v1/orders/order-stops/${orderStopUuid}/accessorials`,
      { data: accessorials },
    );

    if (response.status !== 200) {
      throw new Error(
        response.data?.message ?? "Failed to remove accessorials",
      );
    }

    return response.data;
  } catch (error) {
    console.error(
      "Error removing accessorials:",
      error.response?.data ?? error.message,
    );
    throw new Error(
      error.response?.data?.message ?? "Failed to remove accessorials",
    );
  }
};

export const getAllCategories = async (params = {}) => {
  const query = new URLSearchParams(params).toString();
  const response = await axiosPrivate.get(`/api/v1/categories/all?${query}`);

  return response;
};

export const createCategory = async (values) => {
  const response = await axiosPrivate.post(`/api/v1/categories/create`, values);

  return response;
};

export const updateCategory = async (values) => {
  const response = await axiosPrivate.put(
    `/api/v1/categories/update/${values.uuid}`,
    values,
  );

  return response;
};
export const deleteCategory = async (values) => {
  const response = await axiosPrivate.delete(`/api/v1/categories/delete`, {
    data: values,
  });

  return response;
};

export const getAllTags = async (params = {}) => {
  const query = new URLSearchParams(params).toString();
  const response = await axiosPrivate.get(`/api/v1/tags/all?${query}`);

  return response;
};
export const createTag = async (values) => {
  const response = await axiosPrivate.post(`/api/v1/tags/create`, values);

  return response;
};
export const updateTag = async (values) => {
  const response = await axiosPrivate.put(
    `/api/v1/tags/update/${values.uuid}`,
    values,
  );

  return response;
};
export const deleteTag = async (values) => {
  const response = await axiosPrivate.delete(`/api/v1/tags/delete`, {
    data: values,
  });

  return response;
};
export const getAllFuels = async () => {
  try {
    const response = await axiosPrivate.get(`/api/v1/fuel/all`);

    if (response.status !== 200) {
      throw new Error(response.data.message ?? "Request Failed.");
    }

    return response;
  } catch (error) {
    console.error("Request Error:", error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? "Request Failed.");
  }
};
export const createFuel = async (values) => {
  try {
    const response = await axiosPrivate.post(`/api/v1/fuel/create`, values);

    if (response.status !== 200) {
      throw new Error(response.data.message ?? "Request Failed.");
    }

    return response;
  } catch (error) {
    console.error("Request Error:", error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? "Request Failed.");
  }
};
export const updateFuel = async (values) => {
  try {
    const response = await axiosPrivate.put(
      `/api/v1/fuel/update/${values.uuid}`,
      values,
    );

    if (response.status !== 200) {
      throw new Error(response.data.message ?? "Request Failed.");
    }

    return response;
  } catch (error) {
    console.error("Request Error:", error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? "Request Failed.");
  }
};
export const deleteFuel = async (values) => {
  try {
    const response = await axiosPrivate.delete(`/api/v1/fuel/delete`, {
      data: values,
    });

    if (response.status !== 200) {
      throw new Error(response.data.message ?? "Request Failed.");
    }

    return response;
  } catch (error) {
    console.error("Request Error:", error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? "Request Failed.");
  }
};

export const getAllLanesByTariffId = async (uuid, tarrifType, params = {}) => {
  const query = new URLSearchParams(params).toString();
  const endPoint =
    tarrifType?.toLowerCase() === "cwt"
      ? "cwt-lanes"
      : tarrifType?.toLowerCase() === "pallets"
        ? "pallets-lanes"
        : "pm-lanes";
  const response = await axiosPrivate.get(
    `/api/v1/${endPoint}/tariff/${uuid}?${query}`,
  );

  return response;
};
export const createCwtLane = async (values) => {
  const response = await axiosPrivate.post(`/api/v1/cwt-lanes/create`, values);

  return response;
};
export const deleteCwtLane = async (values) => {
  const response = await axiosPrivate.delete(`/api/v1/cwt-lanes/delete`, {
    data: values,
  });

  return response;
};
export const updateCwtLane = async (uuid, data) => {
  const response = await axiosPrivate.put(
    `/api/v1/cwt-lanes/update/${uuid}`,
    data,
  );

  return response;
};

export const updatepalletsLane = async (uuid, data) => {
  const response = await axiosPrivate.put(
    `/api/v1/pallets-lanes/update/${uuid}`,
    data,
  );

  return response;
};

export const updatePerMileLane = async (uuid, data) => {
  const response = await axiosPrivate.put(
    `/api/v1/pm-lanes/update/${uuid}`,
    data,
  );

  return response;
};

export const createPalletLane = async (values) => {
  const response = await axiosPrivate.post(
    `/api/v1/pallets-lanes/create`,
    values,
  );

  return response;
};

export const updateCwtRanges = async (uuid, values) => {
  const response = await axiosPrivate.put(
    `/api/v1/cwt-ranges/update/${uuid}`,
    values,
  );

  return response;
};

export const updatePMRanges = async (uuid, values) => {
  const response = await axiosPrivate.put(
    `/api/v1/pm-ranges/update/${uuid}`,
    values,
  );

  return response;
};

export const updatePalletRanges = async (uuid, values) => {
  const response = await axiosPrivate.put(
    `/api/v1/pallets-ranges/update/${uuid}`,
    values,
  );

  return response;
};

export const createPMLanes = async (values) => {
  const response = await axiosPrivate.post(`/api/v1/pm-lanes/create`, values);

  return response;
};

export const createPMRanges = async (values) => {
  const response = await axiosPrivate.post(`/api/v1/pm-ranges/create`, values);

  return response;
};

export const createCwtRanges = async (values) => {
  const response = await axiosPrivate.post(`/api/v1/cwt-ranges/create`, values);

  return response;
};

export const deleteCwtRanges = async (values) => {
  const response = await axiosPrivate.delete(`/api/v1/cwt-ranges/delete`, {
    data: values,
  });

  return response;
};

export const getTariffById = async (uuid) => {
  const response = await axiosPrivate.get(`/api/v1/tariffs/find-one/${uuid}`);

  return response;
};
export const getAllTariffs = async (params = {}) => {
  const query = params?.params ? `${params.params}` : "";
  const response = await axiosPrivate.get(`/api/v1/tariffs/all${query}`);
  return response.data.data;
};
export const getTariffs = async () => {
  try {
    const response = await axiosPrivate.get(
      `/api/v1/tariffs/all?page=1&limit=250`,
    );

    if (response.status !== 200) {
      throw new Error(response.data.message ?? "Request Failed.");
    }

    return response;
  } catch (error) {
    console.error("Request Error:", error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? "Request Failed.");
  }
};
export const createTariff = async (values) => {
  const response = await axiosPrivate.post(`/api/v1/tariffs/create`, values);

  return response;
};
export const updateTariff = async (uuid, values) => {
  const response = await axiosPrivate.put(
    `/api/v1/tariffs/update/${uuid}`,
    values,
  );

  return response;
};
export const addTariffToCustomer = async (uuid, values, page) => {
  const response = await axiosPrivate.post(
    `/api/v1/tariffs/${
      page === "customer" ? "customer" : "carrier"
    }/${uuid}/assign-tariff`,
    values,
  );
  return response;
};
export const RemoveTariffForCustomer = async (uuid, values) => {
  try {
    // /{{mickelurl}}/api/v1/tariffs/customer/:customerUuid/remove-tariff
    const response = await axiosPrivate.post(
      `/api/v1/tariffs/customer/${uuid}/remove-tariff`,
      values,
    );

    if (response.status !== 200) {
      throw new Error(response.data.message ?? "Request Failed.");
    }

    return response;
  } catch (error) {
    console.error("Request Error:", error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? "Request Failed.");
  }
};
export const RemoveTariffForCarrier = async (uuid, values) => {
  try {
    // /{{mickelurl}}/api/v1/tariffs/customer/:customerUuid/remove-tariff
    const response = await axiosPrivate.post(
      `/api/v1/tariffs/carrier/${uuid}/remove-tariff`,
      values,
    );

    if (response.status !== 200) {
      throw new Error(response.data.message ?? "Request Failed.");
    }

    return response;
  } catch (error) {
    console.error("Request Error:", error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? "Request Failed.");
  }
};

export const deleteTariff = async (values) => {
  const data = {
    uuids: [values],
  };
  const response = await axiosPrivate.delete(`/api/v1/tariffs/delete`, {
    data: data,
  });

  return response;
};

export const createTariffAccessorial = async (accessorialData) => {
  const response = await axiosPrivate.post(
    "/api/v1/tariff-accessorials/create",
    accessorialData,
  );

  return response;
};
export const bulkCreateTariffAccessorial = async (accessorialData) => {
  const response = await axiosPrivate.post(
    "/api/v1/tariff-accessorials/bulk",
    accessorialData,
  );

  return response;
};
export const getTariffAccessorials = async (uuid) => {
  const response = await axiosPrivate.get(
    `/api/v1/tariff-accessorials/tariff/${uuid}`,
  );

  return response;
};

export const deleteTariffAccessorials = async (uuids) => {
  const response = await axiosPrivate.delete(`/api/v1/tariff-accessorials`, {
    data: { uuids },
  });

  return response;
};

export const getAllEquipments = async (params = {}) => {
  const query = params?.params ? `${params.params}` : "";
  const response = await axiosPrivate.get(`/api/v1/equipments/all${query}`);
  return response.data.data;
};

export const getSingleEquipments = async (id) => {
  const response = await axiosPrivate.get(`/api/v1/equipments/find-one/${id}`);
  return response.data.data;
};

export const getAllEquipmentsTypes = async () => {
  try {
    const response = await axiosPrivate.get(
      `/api/v1/equipment-types/all?page=1&limit=250`,
    );

    if (response.status !== 200) {
      throw new Error(response.data.message ?? "Request Failed.");
    }

    return response;
  } catch (error) {
    console.error("Request Error:", error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? "Request Failed.");
  }
};
export const createEquipmentType = async (values) => {
  try {
    const response = await axiosPrivate.post(
      `/api/v1/equipment-types/create`,
      values,
    );

    if (response.status !== 200) {
      throw new Error(response.data.message ?? "Request Failed.");
    }

    return response;
  } catch (error) {
    console.error("Request Error:", error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? "Request Failed.");
  }
};

export const removeOrdersFromInvoice = async ({ invoiceUuid, orderIds }) => {
  try {
    const response = await axiosPrivate.post(
      `/api/v1/invoices/remove-orders`,
      { invoiceUuid, orderIds }
    );
    if (response.status !== 200) {
      throw new Error(response.data?.message ?? "Request Failed.");
    }
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message ?? "Request Failed.");
  }
};
export const updateEquipmentType = async (values) => {
  try {
    const response = await axiosPrivate.put(
      `/api/v1/equipment-types/update/${values.uuid}`,
      values,
    );

    if (response.status !== 200) {
      throw new Error(response.data.message ?? "Request Failed.");
    }

    return response;
  } catch (error) {
    console.error("Request Error:", error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? "Request Failed.");
  }
};
export const deleteEquipmentType = async (values) => {
  try {
    const response = await axiosPrivate.delete(
      `/api/v1/equipment-types/delete`,
      {
        data: values,
      },
    );

    if (response.status !== 200) {
      throw new Error(response.data.message ?? "Request Failed.");
    }

    return response;
  } catch (error) {
    console.error("Request Error:", error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? "Request Failed.");
  }
};
export const createEquipmentSubType = async (values) => {
  try {
    const response = await axiosPrivate.post(
      `/api/v1/equipment-subtypes/create`,
      values,
    );

    if (response.status !== 200) {
      throw new Error(response.data.message ?? "Request Failed.");
    }

    return response;
  } catch (error) {
    console.error("Request Error:", error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? "Request Failed.");
  }
};
export const updateEquipmentSubType = async (values) => {
  try {
    const response = await axiosPrivate.put(
      `/api/v1/equipment-subtypes/update/${values.uuid}`,
      values,
    );

    if (response.status !== 200) {
      throw new Error(response.data.message ?? "Request Failed.");
    }

    return response;
  } catch (error) {
    console.error("Request Error:", error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? "Request Failed.");
  }
};
export const deleteEquipmentSubType = async (values) => {
  try {
    const response = await axiosPrivate.delete(
      `/api/v1/equipment-subtypes/delete`,
      {
        data: values,
      },
    );

    if (response.status !== 200) {
      throw new Error(response.data.message ?? "Request Failed.");
    }

    return response;
  } catch (error) {
    console.error("Request Error:", error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? "Request Failed.");
  }
};

export const getServices = async () => {
  try {
    const response = await axiosPrivate.get(`/api/v1/services/all`);

    if (response.status !== 200) {
      throw new Error(response.data.message ?? "Request Failed.");
    }

    return response;
  } catch (error) {
    console.error("Request Error:", error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? "Request Failed.");
  }
};

export const getServicesActive = async () => {
  try {
    const response = await axiosPrivate.get(`/api/v1/services/active`);

    if (response.status !== 200) {
      throw new Error(response.data.message ?? "Request Failed.");
    }

    return response;
  } catch (error) {
    console.error("Request Error:", error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? "Request Failed.");
  }
};

export const getServiceTypes = async () => {
  try {
    const response = await axiosPrivate.get(`/api/v1/service-types/all`);

    if (response.status !== 200) {
      throw new Error(response.data.message ?? "Request Failed.");
    }

    return response;
  } catch (error) {
    console.error("Request Error:", error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? "Request Failed.");
  }
};

export const createService = async (values) => {
  try {
    const response = await axiosPrivate.post(`/api/v1/services/create`, values);

    if (response.status !== 200) {
      throw new Error(response.data.message ?? "Request Failed.");
    }

    return response;
  } catch (error) {
    console.error("Request Error:", error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? "Request Failed.");
  }
};

export const updateService = async (values) => {
  try {
    const response = await axiosPrivate.put(
      `/api/v1/services/update/${values.uuid}`,
      values,
    );

    if (response.status !== 200) {
      throw new Error(response.data.message ?? "Request Failed.");
    }

    return response;
  } catch (error) {
    console.error("Request Error:", error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? "Request Failed.");
  }
};

export const deleteService = async (values) => {
  try {
    const response = await axiosPrivate.delete(`/api/v1/services/delete`, {
      data: values,
    });

    if (response.status !== 200) {
      throw new Error(response.data.message ?? "Request Failed.");
    }

    return response;
  } catch (error) {
    console.error("Request Error:", error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? "Request Failed.");
  }
};

export const updateServiceStatus = async (uuid, values) => {
  try {
    const response = await axiosPrivate.put(
      `/api/v1/services/update/${uuid}`,
      values,
    );

    if (response.status !== 200) {
      throw new Error(response.data.message ?? "Request Failed.");
    }

    return response;
  } catch (error) {
    console.error("Request Error:", error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? "Request Failed.");
  }
};

export const getAllTerminals = async () => {
  try {
    const response = await axiosPrivate.get(`/api/v1/terminals/all`);

    if (response.status !== 200) {
      throw new Error(response.data.message ?? "Request Failed.");
    }

    return response;
  } catch (error) {
    console.error("Request Error:", error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? "Request Failed.");
  }
};
export const createTerminal = async (values) => {
  try {
    const response = await axiosPrivate.post(
      `/api/v1/terminals/create`,
      values,
    );

    if (response.status !== 200) {
      throw new Error(response.data.message ?? "Request Failed.");
    }

    return response;
  } catch (error) {
    console.error("Request Error:", error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? "Request Failed.");
  }
};
export const updateTerminal = async (values) => {
  try {
    const response = await axiosPrivate.put(
      `/api/v1/terminals/update/${values.uuid}`,
      values,
    );

    if (response.status !== 200) {
      throw new Error(response.data.message ?? "Request Failed.");
    }

    return response;
  } catch (error) {
    console.error("Request Error:", error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? "Request Failed.");
  }
};
export const deleteTerminal = async (values) => {
  try {
    const response = await axiosPrivate.delete(`/api/v1/terminals/delete`, {
      data: values,
    });

    if (response.status !== 200) {
      throw new Error(response.data.message ?? "Request Failed.");
    }

    return response;
  } catch (error) {
    console.error("Request Error:", error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? "Request Failed.");
  }
};

export const getPaymentTypes = async () => {
  try {
    const response = await axiosPrivate.get(
      `/api/v1/payment-terms/all?page=1&limit=250`,
    );

    if (response.status !== 200) {
      throw new Error(response.data.message ?? "Request Failed.");
    }

    return response;
  } catch (error) {
    console.error("Request Error:", error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? "Request Failed.");
  }
};

// Payment Terms API
export const getPaymentTerms = async () => {
  try {
    const response = await axiosPrivate.get(
      `/api/v1/payment-terms/all?page=1&limit=250`,
    );

    if (response.status !== 200) {
      throw new Error(response.data.message ?? "Request Failed.");
    }

    return response;
  } catch (error) {
    console.error("Request Error:", error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? "Request Failed.");
  }
};

export const createPaymentTerm = async (paymentTerm) => {
  try {
    const response = await axiosPrivate.post(
      `/api/v1/payment-terms/create`,
      paymentTerm,
    );

    if (response.status !== 200) {
      throw new Error(response.data.message ?? "Request Failed.");
    }

    return response;
  } catch (error) {
    console.error("Request Error:", error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? "Request Failed.");
  }
};

export const updatePaymentTerm = async (paymentTerm) => {
  try {
    const response = await axiosPrivate.put(
      `/api/v1/payment-terms/update/${paymentTerm.uuid}`,
      paymentTerm,
    );

    if (response.status !== 200) {
      throw new Error(response.data.message ?? "Request Failed.");
    }

    return response;
  } catch (error) {
    console.error("Request Error:", error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? "Request Failed.");
  }
};

export const deletePaymentTerm = async (values) => {
  try {
    const response = await axiosPrivate.delete(`/api/v1/payment-terms/delete`, {
      data: values,
    });

    if (response.status !== 200) {
      throw new Error(response.data.message ?? "Request Failed.");
    }

    return response;
  } catch (error) {
    console.error("Request Error:", error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? "Request Failed.");
  }
};

// Tax Table API
export const getAllTaxes = async () => {
  try {
    const response = await axiosPrivate.get(`/api/v1/taxes/all`);

    if (response.status !== 200) {
      throw new Error(response.data.message ?? "Request Failed.");
    }

    return response;
  } catch (error) {
    console.error("Request Error:", error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? "Request Failed.");
  }
};
export const createTax = async (tax) => {
  try {
    const response = await axiosPrivate.post(`/api/v1/taxes/create`, tax);

    if (response.status !== 200) {
      throw new Error(response.data.message ?? "Request Failed.");
    }

    return response;
  } catch (error) {
    console.error("Request Error:", error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? "Request Failed.");
  }
};

export const updateTax = async (tax) => {
  try {
    const response = await axiosPrivate.put(
      `/api/v1/taxes/update/${tax.uuid}`,
      tax,
    );

    if (response.status !== 200) {
      throw new Error(response.data.message ?? "Request Failed.");
    }

    return response;
  } catch (error) {
    console.error("Request Error:", error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? "Request Failed.");
  }
};

export const deleteTax = async (values) => {
  try {
    const response = await axiosPrivate.delete(`/api/v1/taxes/delete`, {
      data: values,
    });

    if (response.status !== 200) {
      throw new Error(response.data.message ?? "Request Failed.");
    }

    return response;
  } catch (error) {
    console.error("Request Error:", error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? "Request Failed.");
  }
};

export const getDriversData = async () => {
  try {
    const response = await axiosPrivate.get(
      `/api/v1/users/all?page=1&limit=250`,
    );

    if (response.status !== 200) {
      throw new Error(response.data.message ?? "Request Failed.");
    }

    return response;
  } catch (error) {
    console.error("Request Error:", error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? "Request Failed.");
  }
};

export const getEquipmentSubTypes = async () => {
  try {
    const response = await axiosPrivate.get(
      `/api/v1/equipment-subtypes/all?page=1&limit=250`,
    );

    if (response.status !== 200) {
      throw new Error(response.data.message ?? "Request Failed.");
    }

    return response;
  } catch (error) {
    console.error("Request Error:", error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? "Request Failed.");
  }
};
export const getUsersSelect = async () => {
  try {
    const response = await axiosPrivate.get(
      `/api/v1/users/all?page=1&limit=250`,
    );

    if (response.status !== 200) {
      throw new Error(response.data.message ?? "Request Failed.");
    }

    return response;
  } catch (error) {
    console.error("Request Error:", error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? "Request Failed.");
  }
};

export const createEquipment = async (values) => {
  try {
    const response = await axiosPrivate.post(
      `/api/v1/equipments/create`,
      values,
    );

    return response;
  } catch (error) {
    console.error("Request Error:", error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? "Request Failed.");
  }
};

export const updateEquipment = async (values) => {
  try {
    const isFormData = values instanceof FormData;

    const response = await axiosPrivate.put(
      `/api/v1/equipments/update/${
        isFormData ? values.get("uuid") : values.uuid
      }`,
      values,
      isFormData
        ? {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        : undefined,
    );

    return response;
  } catch (error) {
    const errorMessage = error.response?.data?.message ?? "Request Failed.";
    console.error("Request Error:", error.response?.data ?? error.message);
    throw new Error(errorMessage);
  }
};

export const deleteEquipment = async (values) => {
  try {
    const response = await axiosPrivate.delete(`/api/v1/equipments/delete`, {
      data: values, // Pass values in the `data` property
    });

    return response;
  } catch (error) {
    console.error("Request Error:", error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? "Request Failed.");
  }
};

export const getAllCarriers = async (params = {}) => {
  const query = params?.params ? `${params.params}` : "";

  const response = await axiosPrivate.get(`/api/v1/carriers/all?${query}`);

  return response.data.data;
};
export const getCarrier = async (uuid) => {
  try {
    const response = await axiosPrivate.get(
      `/api/v1/carriers/find-one/${uuid}`,
    );

    if (response.status !== 200) {
      throw new Error(response.data.message ?? "Request Failed.");
    }

    return response;
  } catch (error) {
    console.error("Request Error:", error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? "Request Failed.");
  }
};

export const getDrivers = async (params = {}) => {
  const query = new URLSearchParams(params).toString();
  const response = await axiosPrivate.get(`/api/v1/users/all/drivers?${query}`);

  if (response.status !== 200)
    throw new Error(response.data ?? "Request Failed.");
  return response.data.data;
};
export const getUsers = async (params = {}) => {
  const query = params?.params ? `${params.params}` : "";
  const response = await axiosPrivate.get(`/api/v1/users/all${query}`);
  if (response.status !== 200)
    throw new Error(response.data ?? "Request Failed.");
  return response.data.data;
};

export const addUser = async (values) => {
  const response = await axiosPrivate.post(`/api/v1/users/create`, values);
  return response;
};

// export const updateUsers = async (values) => {
//   const response = await axiosPrivate.put(
//     `/api/v1/users/update/${values.uuid}`,
//     values
//   );

//   return response;
// };

export const updateUsers = async (values) => {
  // Check if values is FormData (contains files) or regular object
  const isFormData = values instanceof FormData;

  // Extract UUID for the URL
  const uuid = isFormData ? values.get("uuid") : values.uuid;

  const config = {
    headers: {
      // Set content type based on data type
      "Content-Type": isFormData ? "multipart/form-data" : "application/json",
    },
  };

  const response = await axiosPrivate.put(
    `/api/v1/users/update/${uuid}`,
    values, // This will be either FormData or regular object
    config,
  );

  return response;
};

export const updateUserRolePermissions = async (payload) => {
  try {
    const response = await axiosPrivate.put(
      `/api/v1/users/update-role-permissions`,
      payload,
    );

    if (response.status !== 200) {
      throw new Error(response.data?.message ?? "Request Failed.");
    }

    return response;
  } catch (error) {
    console.error("Request Error:", error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? "Request Failed.");
  }
};

export const getCustomers = async (params = {}) => {
  const query = params?.params ? `${params.params}` : "";
  const response = await axiosPrivate.get(`/api/v1/customers/all${query}`);
  if (response.status !== 200) {
    throw new Error(response.data ?? "Request Failed.");
  }
  return response.data.data;
};

export const getTableView = async (tableName = "") => {
  const response = await axiosPrivate.get(
    `/api/v1/table-views/find-by-table/${tableName}`,
  );
  if (response.status !== 200) {
    throw new Error(response.data ?? "Request Failed.");
  }
  return response.data.data;
};

export const createTableView = async (body) => {
  const response = await axiosPrivate.post(`/api/v1/table-views/create`, body);
  if (response.status !== 201) {
    throw new Error(response.data ?? "Request Failed.");
  }
  return response.data.data;
};

export const updateTableView = async (uuid = "", body) => {
  const response = await axiosPrivate.put(
    `/api/v1/table-views/update/${uuid}`,
    body,
  );
  if (response.status !== 200) {
    throw new Error(response.data ?? "Request Failed.");
  }
  return response.data.data;
};

export const deleteTableView = async (uuid = "") => {
  const response = await axiosPrivate.delete(
    `/api/v1/table-views/delete/${uuid}`,
  );
  if (response.status !== 200) {
    throw new Error(response.data ?? "Request Failed.");
  }
  return response.data.data;
};

export const getAccountSettings = async () => {
  const response = await axiosPrivate.get(`/api/v1/company-settings/all`);
  if (response.status !== 200) {
    throw new Error(response.data ?? "Request Failed.");
  }
  return response.data.data;
};

export const createAccountSettings = async (values) => {
  const response = await axiosPrivate.post(
    `/api/v1/company-settings/create`,
    values,
  );
  if (response.status !== 201) {
    throw new Error(response.data ?? "Request Failed.");
  }
  return response.data.data;
};

export const updateAccountSettings = async (uuid, values) => {
  const response = await axiosPrivate.put(
    `/api/v1/company-settings/update/${uuid}`,
    values,
  );
  if (response.status !== 200) {
    throw new Error(response.data ?? "Request Failed.");
  }
  return response.data.data;
};

export const getTags = async (params = {}) => {
  const query = params?.params ? `${params.params}` : "";
  const response = await axiosPrivate.get(`/api/v1/tags/all?${query}`);
  if (response.status !== 200) {
    throw new Error(response.data ?? "Request Failed.");
  }
  return response.data.data;
};

export const getProblemTypes = async () => {
  const response = await axiosPrivate.get(`/api/v1/problem-types/all`);
  if (response.status !== 200) {
    throw new Error(response.data ?? "Request Failed.");
  }
  return response.data.data;
};

export const createProblemTerms = async (values) => {
  const response = await axiosPrivate.post(
    `/api/v1/problem-types/create`,
    values,
  );
  if (response.status !== 200) {
    throw new Error(response.data ?? "Request Failed.");
  }
  return response.data.data;
};

export const updateProblemTerms = async (uuid, values) => {
  const response = await axiosPrivate.put(
    `/api/v1/problem-types/update/${uuid}`,
    values,
  );
  if (response.status !== 200) {
    throw new Error(response.data ?? "Request Failed.");
  }
  return response.data.data;
};

export const getTermsAndConditions = async () => {
  const response = await axiosPrivate.get(`/api/v1/terms-and-conditions/all`);
  if (response.status !== 200) {
    throw new Error(response.data ?? "Request Failed.");
  }
  return response.data.data;
};

export const createTermsAndConditions = async (values) => {
  const response = await axiosPrivate.post(
    `/api/v1/terms-and-conditions/create`,
    values,
  );
  if (response.status !== 201) {
    throw new Error(response.data ?? "Request Failed.");
  }
  return response.data.data;
};

export const updateTermsAndConditions = async (uuid, values) => {
  const response = await axiosPrivate.put(
    `/api/v1/terms-and-conditions/update/${uuid}`,
    values,
  );
  if (response.status !== 200) {
    throw new Error(response.data ?? "Request Failed.");
  }
  return response.data.data;
};

export const deleteTermsAndConditions = async (uuids) => {
  const response = await axiosPrivate.delete(
    `/api/v1/terms-and-conditions/delete`,
    { data: { uuids } },
  );
  if (response.status !== 200) {
    throw new Error(response.data ?? "Request Failed.");
  }
  return response.data.data;
};

export const getAccessorials = async () => {
  const response = await axiosPrivate.get(`/api/v1/accessorials/all`);
  if (response.status !== 200) {
    throw new Error(response.data ?? "Request Failed.");
  }
  return response.data.data;
};

export const updateOrderStatus = async (uuid, status) => {
  const payload = {
    status: status,
  };
  const response = await axiosPrivate.put(
    `/api/v1/orders/update/status/${uuid}`,
    payload,
  );
  if (response.status !== 200) {
    throw new Error(response.data ?? "Request Failed.");
  }
  return response.data.data;
};

// export const getCommiditiesByOrderId = async (id) => {
//   try {
//     const response = await axiosPrivate.get(`/api/v1/commodities/order/:uuid`);

//     if (response.status !== 200) {
//       throw new Error(response.data.message ?? "Request Failed.");
//     }

//     return response;
//   } catch (error) {
//     console.error("Request Error:", error.response?.data ?? error.message);
//     throw new Error(error.response?.data?.message ?? "Request Failed.");
//   }
// };

export const reorderManifestStops = async (payload) => {
  try {
    const response = await axiosPrivate.put(
      `/api/v1/manifests/reorder-stops`,
      payload,
    );

    if (response.status !== 200) {
      throw new Error(response.data?.message ?? "Request Failed.");
    }

    return response.data.data; // Assuming the API returns the updated stops in data.data
  } catch (error) {
    console.error("Request Error:", error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? "Request Failed.");
  }
};

export const createQouteApi = async (values) => {
  const response = await axiosPrivate.post(`/api/v1/quotes/create`, values);
  if (response.status !== 200) {
    throw new Error(response.data ?? "Request Failed.");
  }
  if (response.data.data) {
    return response.data.data;
  } else {
    return response.data;
  }
};
export const createQouteApiMultiStop = async (values) => {
  const response = await axiosPrivate.post(`/api/v1/quotes/create`, values);
  if (response.status !== 200) {
    throw new Error(response.data ?? "Request Failed.");
  }
  if (response.data.data) {
    return response.data.data;
  } else {
    return response.data;
  }
};

export const updateQuoteApiMultiStop = async (values) => {
  const response = await axiosPrivate.post(
    `/api/v1/quotes/update-per-stop`,
    values,
  );
  if (response.status !== 200) {
    throw new Error(response.data ?? "Request Failed.");
  }
  if (response.data.data) {
    return response.data.data;
  } else {
    return response.data;
  }
};

export const updateQouteApi = async (uuid, values) => {
  const response = await axiosPrivate.put(
    `/api/v1/quotes/update/${uuid}`,
    values,
  );
  if (response.status !== 200) {
    throw new Error(response.data ?? "Request Failed.");
  }
  if (response.data.data) {
    return response.data.data;
  } else {
    return response.data;
  }
};

export const getTermsAndConidions = async () => {
  const response = await axiosPrivate.get(`/api/v1/terms-and-conditions/all`);
  if (response.status !== 200) {
    throw new Error(response.data ?? "Request Failed.");
  }
  return response.data.data;
};

export const getQouteById = async (uuid) => {
  const response = await axiosPrivate.get(`/api/v1/quotes/find-one/${uuid}`);
  if (response.status !== 200) {
    throw new Error(response.data ?? "Request Failed.");
  }
  return response.data.data;
};
export const getAllQuotesForOrderStopsByOrder = async (uuid) => {
  const response = await axiosPrivate.get(
    `/api/v1/quotes/quotes-per-stop/${uuid}`,
  );
  if (response.status !== 200) {
    throw new Error(response.data ?? "Request Failed.");
  }
  return response.data.data;
};

export const selectQouteApi = async (id, uuid) => {
  const response = await axiosPrivate.put(`/api/v1/quotes/select/${uuid}`, {
    uuid: id,
  });
  if (response.status !== 200) {
    throw new Error(response.data ?? "Request Failed.");
  }
  return response.data.data;
};

export const deleteQouteApi = async (uuid) => {
  const response = await axiosPrivate.delete(`/api/v1/quotes/delete`, {
    data: { uuids: [uuid] },
  });
  if (response.status !== 200) {
    throw new Error(response.data ?? "Request Failed.");
  }
  return response.data.data;
};

export const getTotalWeightComm = async (values) => {
  const response = await axiosPrivate.put(
    `/api/v1/commodities/get-bundle-weight`,
    values,
  );
  if (response.status !== 200) {
    throw new Error(response.data ?? "Request Failed.");
  }
  return response.data.data;
};

export const deleteLeg = async (uuids) => {
  try {
    const response = await axiosPrivate.delete(`/api/v1/legs/delete`, {
      data: { uuids },
    });
    if (response.status !== 200) {
      throw new Error(response.data?.message ?? "Request Failed.");
    }
    return response.data.data;
  } catch (error) {
    console.error("Request Error:", error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? "Request Failed.");
  }
};

export const completeLeg = async (legUuid) => {
  try {
    const response = await axiosPrivate.put(`/api/v1/legs/complete/${legUuid}`);
    if (response.status !== 200) {
      throw new Error(response.data?.message ?? "Request Failed.");
    }
    return response.data;
  } catch (error) {
    console.error("Request Error:", error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? "Request Failed.");
  }
};

export const splitLeg = async (legUuid, payload) => {
  try {
    const response = await axiosPrivate.put(
      `/api/v1/legs/split/${legUuid}`,
      payload,
    );
    if (response.status !== 200) {
      throw new Error(response.data?.message ?? "Request Failed.");
    }
    return response.data.data;
  } catch (error) {
    console.error("Request Error:", error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? "Request Failed.");
  }
};

export const updateLegIsLineHaul = async (legUuid, isLineHaul = true) => {
  try {
    const response = await axiosPrivate.put(
      `/api/v1/legs/${legUuid}/is-line-haul`,
      { isLineHaul },
    );
    if (response.status !== 200) {
      throw new Error(response.data?.message ?? "Request Failed.");
    }
    return response.data?.data ?? response.data;
  } catch (error) {
    console.error("Request Error:", error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? "Request Failed.");
  }
};

export const getAllCustomerAddresses = async (uuid) => {
  const response = await axiosPrivate.get(
    `/api/v1/customer-addresses/customer/${uuid}`,
  );
  if (response.status !== 200) {
    throw new Error(response.data ?? "Request Failed.");
  }
  return response.data.data;
};

export const assignCarrierToLeg = async (
  legUuid,
  carrierId,
  manifestUuid = "",
) => {
  try {
    const payload = {
      carrierId,
      manifestUuid,
    };
    const response = await axiosPrivate.put(
      `/api/v1/legs/assign-carrier/${legUuid}`,
      payload,
    );
    if (response.status !== 200) {
      throw new Error(response.data?.message ?? "Request Failed.");
    }
    return response.data.data;
  } catch (error) {
    console.error("Request Error:", error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? "Request Failed.");
  }
};

export const assignCarrierWithLegToManifest = async (payload) => {
  try {
    const { carrierUuid, legUuid, manifestUuid } = payload;
    const requestPayload = {
      carrierUuid,
      legUuid,
      ...(manifestUuid && { manifestUuid }),
    };
    const response = await axiosPrivate.post(
      `/api/v1/manifests/assign-carrier-with-leg`,
      requestPayload,
    );
    if (response.status !== 200 && response.status !== 201) {
      throw new Error(response.data?.message ?? "Request Failed.");
    }
    return response.data.data;
  } catch (error) {
    console.error("Request Error:", error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? "Request Failed.");
  }
};

export const addLegToManifest = async (manifestUuid, legUuid) => {
  try {
    const payload = {
      legUuid,
    };
    const response = await axiosPrivate.post(
      `/api/v1/manifests/add-leg${manifestUuid ? `/${manifestUuid}` : ""}`,
      payload,
    );
    if (response.status !== 200) {
      throw new Error(response.data?.message ?? "Request Failed.");
    }
    return response.data.data;
  } catch (error) {
    console.error("Request Error:", error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? "Request Failed.");
  }
};

export const removeLegFromManifest = async (manifestUuid, legUuid) => {
  try {
    const response = await axiosPrivate.delete(
      `/api/v1/manifests/${manifestUuid}/leg/${legUuid}`,
    );
    if (response.status !== 200 && response.status !== 204) {
      throw new Error(response.data?.message ?? "Request Failed.");
    }
    return response.data;
  } catch (error) {
    console.error("Request Error:", error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? "Request Failed.");
  }
};

export const addStopToManifest = async (stopData) => {
  try {
    const response = await axiosPrivate.post(`/api/v1/stops/create`, stopData);
    if (response.status !== 200 && response.status !== 201) {
      throw new Error(response.data?.message ?? "Request Failed.");
    }
    return response.data.data;
  } catch (error) {
    console.error("Request Error:", error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? "Request Failed.");
  }
};

export const deleteManifestStops = async (uuids) => {
  try {
    const response = await axiosPrivate.delete(`/api/v1/stops/delete`, {
      data: { uuids },
    });
    if (response.status !== 200 && response.status !== 204) {
      throw new Error(response.data?.message ?? "Request Failed.");
    }
    return response.data;
  } catch (error) {
    console.error("Request Error:", error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? "Request Failed.");
  }
};

export const deleteManifests = async (uuids) => {
  try {
    const response = await axiosPrivate.delete(`/api/v1/manifests/delete`, {
      data: { uuids },
    });
    if (response.status !== 200 && response.status !== 204) {
      throw new Error(response.data?.message ?? "Request Failed.");
    }
    return response.data;
  } catch (error) {
    console.error("Request Error:", error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? "Request Failed.");
  }
};

export const assignEquipmentToLeg = async (legUuid, equipmentUuids) => {
  try {
    const payload = {
      equipmentUuids,
    };
    const response = await axiosPrivate.put(
      `/api/v1/legs/assign-equipment/${legUuid}`,
      payload,
    );
    if (response.status !== 200) {
      throw new Error(response.data?.message ?? "Request Failed.");
    }
    return response.data.data;
  } catch (error) {
    console.error("Request Error:", error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? "Request Failed.");
  }
};

export const getAllManifests = async (params = {}) => {
  const query = params?.params ? `${params.params}` : "";
  try {
    const response = await axiosPrivate.get(
      `/api/v1/manifests/all${query ? query : "?page=1&limit=500"}`,
    );
    if (response.status !== 200) {
      throw new Error(response.data?.message ?? "Request Failed.");
    }
    return response.data;
  } catch (error) {
    console.error("Request Error:", error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? "Request Failed.");
  }
};

export const createManifest = async (legUuid, isOSND = false) => {
  try {
    const response = await axiosPrivate.post(`/api/v1/manifests/create`, {
      legUuid,
      isOSND,
    });
    if (response.status !== 200) {
      throw new Error(response.data?.message ?? "Request Failed.");
    }
    return response.data.data;
  } catch (error) {
    console.error("Request Error:", error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? "Request Failed.");
  }
};

export const createWithDriver = async ({
  driverUuid,
  carrierUuid,
  legUuid,
  isOSND = false,
}) => {
  try {
    const payload = {};
    if (driverUuid) payload.driverUuid = driverUuid;
    if (carrierUuid) payload.carrierUuid = carrierUuid;
    if (legUuid) payload.legUuid = legUuid;
    payload.isOSND = isOSND;

    const response = await axiosPrivate.post(
      `/api/v1/manifests/create-with-driver`,
      payload,
    );
    if (response.status !== 200) {
      throw new Error(response.data?.message ?? "Request Failed.");
    }
    return response.data.data;
  } catch (error) {
    console.error("Request Error:", error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? "Request Failed.");
  }
};

export const assignDriverToManifest = async (manifestUuid, driverUuid) => {
  try {
    const payload = {
      driverUuid,
    };
    const response = await axiosPrivate.put(
      `/api/v1/manifests/assign-driver/${manifestUuid}`,
      payload,
    );
    if (response.status !== 200) {
      throw new Error(response.data?.message ?? "Request Failed.");
    }
    return response.data.data;
  } catch (error) {
    console.error("Request Error:", error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? "Request Failed.");
  }
};

export const unassignDriverFromManifest = async (manifestUuid) => {
  try {
    const payload = {
      driverUuid: null,
    };
    const response = await axiosPrivate.put(
      `/api/v1/manifests/assign-driver/${manifestUuid}`,
      payload,
    );
    if (response.status !== 200) {
      throw new Error(response.data?.message ?? "Request Failed.");
    }
    return response.data.data;
  } catch (error) {
    console.error("Request Error:", error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? "Request Failed.");
  }
};

export const updateManifestName = async (manifestUuid, manifestName) => {
  try {
    const response = await axiosPrivate.put(
      `/api/v1/manifests/${manifestUuid}/name`,
      { manifestName },
    );
    if (response.status !== 200) {
      throw new Error(response.data?.message ?? "Request Failed.");
    }
    return response.data.data;
  } catch (error) {
    console.error("Request Error:", error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? "Request Failed.");
  }
};

export const updateManifestStatus = async (manifestUuid, status) => {
  try {
    const payload = {
      status,
    };
    const response = await axiosPrivate.put(
      `/api/v1/manifests/${manifestUuid}/status`,
      payload,
    );
    if (response.status !== 200) {
      throw new Error(response.data?.message ?? "Request Failed.");
    }
    return response.data.data;
  } catch (error) {
    console.error("Request Error:", error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? "Request Failed.");
  }
};

export const assignEquipmentToManifest = async (
  manifestUuid,
  equipmentUuids,
) => {
  try {
    const payload = {
      equipmentUuids,
    };
    const response = await axiosPrivate.put(
      `/api/v1/manifests/assign-equipment/${manifestUuid}`,
      payload,
    );
    if (response.status !== 200) {
      throw new Error(response.data?.message ?? "Request Failed.");
    }
    return response.data.data;
  } catch (error) {
    console.error("Request Error:", error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? "Request Failed.");
  }
};

export const removeEquipmentFromManifest = async (
  manifestUuid,
  equipmentUuid,
) => {
  try {
    const payload = {
      equipmentUuid,
    };
    const response = await axiosPrivate.put(
      `/api/v1/manifests/${manifestUuid}/remove-equipment`,
      payload,
    );
    if (response.status !== 200) {
      throw new Error(response.data?.message ?? "Request Failed.");
    }
    return response.data.data;
  } catch (error) {
    console.error("Request Error:", error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? "Request Failed.");
  }
};

export const updateMiscellaneousCosts = async (manifestUuid, payload) => {
  try {
    const response = await axiosPrivate.put(
      `/api/v1/manifest-costs/${manifestUuid}/miscellaneous`,
      payload,
    );
    if (response.status !== 200) {
      throw new Error(response.data?.message ?? "Request Failed.");
    }
    return response.data.data;
  } catch (error) {
    console.error("Request Error:", error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? "Request Failed.");
  }
};

export const createInvoice = async (values) => {
  try {
    const response = await axiosPrivate.post(`/api/v1/invoices`, values);
    if (response.status !== 200) {
      throw new Error(response.data.message ?? "Request Failed.");
    }

    return response;
  } catch (error) {
    console.error("Request Error:", error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? "Request Failed.");
  }
};

export const getInvoices = async (params = {}) => {
  const query = params?.params ? `${params.params}` : "";
  try {
    const response = await axiosPrivate.get(`/api/v1/invoices${query}`);

    if (response.status !== 200) {
      throw new Error(response.data.message ?? "Request Failed.");
    }
    return response.data;
  } catch (error) {
    console.error("Request Error:", error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? "Request Failed.");
  }
};

export const getSingleInvoice = async (uuid) => {
  try {
    const response = await axiosPrivate.get(`/api/v1/invoices/${uuid}`);

    if (response.status !== 200) {
      throw new Error(response.data.message ?? "Request Failed.");
    }
    return response.data;
  } catch (error) {
    console.error("Request Error:", error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? "Request Failed.");
  }
};

export const updateInvoice = async (values) => {
  try {
    const response = await axiosPrivate.put(`/api/v1/invoices/update`, values);

    if (response.status !== 200) {
      throw new Error(response.data.message ?? "Request Failed.");
    }
    return response.data;
  } catch (error) {
    console.error("Request Error:", error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? "Request Failed.");
  }
};

export const sendInvoice = async (values) => {
  try {
    const response = await axiosPrivate.post(`/api/v1/invoices/send`, values);

    if (response.status !== 200) {
      throw new Error(response.data.message ?? "Request Failed.");
    }
    return response.data;
  } catch (error) {
    console.error("Request Error:", error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? "Request Failed.");
  }
};

export const deleteInvoice = async (uuids) => {
  try {
    // Ensure uuids is an array
    const uuidsArray = Array.isArray(uuids) ? uuids : [uuids];
    const response = await axiosPrivate.delete(`/api/v1/invoices/delete`, {
      data: { uuids: uuidsArray },
    });
    return response;
  } catch (error) {
    console.error("Request Error:", error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? "Request Failed.");
  }
};

export const exportInvoice = async (values) => {
  try {
    const response = await axiosPrivate.post(
      `/api/v1/invoices/export`,
      values,
      {
        responseType: "blob",
      },
    );

    if (response.status !== 200) {
      throw new Error(response.data.message ?? "Request Failed.");
    }

    // Return response with data and headers for file download
    return {
      data: response.data,
      headers: response.headers,
      type: values.type, // Include type for file extension
    };
  } catch (error) {
    console.error("Request Error:", error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? "Request Failed.");
  }
};

export const markAsPaid = async (values) => {
  try {
    const response = await axiosPrivate.put(
      `/api/v1/invoices/mark-as-paid`,
      values,
    );
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message ?? "Request Failed.");
  }
};

export const getSinglePublicInvoice = async (uuid) => {
  try {
    const response = await axiosPublic.get(`/api/v1/public/invoices/${uuid}`);

    if (response.status !== 200) {
      throw new Error(response.data.message ?? "Request Failed.");
    }
    return response.data;
  } catch (error) {
    console.error("Request Error:", error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? "Request Failed.");
  }
};

export const getSendInvoices = async (invoiceUuids) => {
  const response = await axiosPrivate.get(
    `/api/v1/invoices/customer/${invoiceUuids}`,
  );
  if (response.status !== 200) {
    throw new Error(response.data.message ?? "Request Failed.");
  }
  return response.data;
};

export const deleteOrder = async (uuids) => {
  try {
    // Ensure uuids is an array
    const uuidsArray = Array.isArray(uuids) ? uuids : [uuids];
    const response = await axiosPrivate.delete(`/api/v1/orders/delete`, {
      data: { uuids: uuidsArray },
    });
    return response;
  } catch (error) {
    console.error("Request Error:", error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? "Request Failed.");
  }
};

export const getQuickBooksActivity = async (quickbookId) => {
  const response = await axiosPrivate.get(
    `/api/v1/invoices/qb/${quickbookId}/activity`,
  );
  if (response.status !== 200) {
    throw new Error(response.data.message ?? "Request Failed.");
  }
  return response.data;
};

export const syncInvoiceToQuickBooks = async (invoiceId) => {
  try {
    const response = await axiosPrivate.post(
      `/api/v1/invoices/qb/${invoiceId}/sync`,
    );
    if (response.status !== 200) {
      throw new Error(response.data.message ?? "Request Failed.");
    }
    return response.data;
  } catch (error) {
    console.error("Request Error:", error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? "Request Failed.");
  }
};

export const duplicateOrder = async (uuid) => {
  try {
    const response = await axiosPrivate.post(
      `/api/v1/orders/duplicate/${uuid}`,
    );
    if (response.status !== 200 && response.status !== 201) {
      throw new Error(response.data?.message ?? "Request Failed.");
    }
    return response.data?.data ?? response.data;
  } catch (error) {
    console.error("Request Error:", error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? "Request Failed.");
  }
};

export const createOrderNote = async (noteData) => {
  try {
    const response = await axiosPrivate.post("/api/v1/order-notes", noteData);
    return response.data;
  } catch (error) {
    console.error("Error creating order note:", error);
    throw error;
  }
};

// Get all order notes by orderId or manifestId
export const getOrderNotes = async (orderId, manifestId) => {
  try {
    const params = new URLSearchParams();
    if (orderId) params.append("orderId", orderId);
    if (manifestId) params.append("manifestId", manifestId);

    const response = await axiosPrivate.get(
      `/api/v1/order-notes?${params.toString()}`,
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching order notes:", error);
    throw error;
  }
};

export const sendConfirmation = async (uuid, orderStopUuid) => {
  try {
    const response = await axiosPrivate.post(
      `/api/v1/orders/send-confirmation/${uuid}`,
      {
        orderStopUuid,
      },
    );
    if (response.status !== 200 && response.status !== 201) {
      throw new Error(response.data?.message ?? "Request Failed.");
    }
    return response.data;
  } catch (error) {
    console.error("Request Error:", error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? "Request Failed.");
  }
};

export const addOrdersToInvoice = async (invoiceUuid, orderIds) => {
  try {
    const response = await axiosPrivate.post(
      `/api/v1/invoices/add-orders`,
      {
        invoiceUuid,
        orderIds,
      },
    );
    if (response.status !== 200 && response.status !== 201) {
      throw new Error(response.data?.message ?? "Request Failed.");
    }
    return response.data;
  } catch (error) {
    console.error("Request Error:", error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? "Request Failed.");
  }
};
